import React, { useCallback, useEffect, useState } from 'react'
import { EnhancedInputField } from './EnhancedInputField'
import axios from 'axios';
import { API } from '../../shared/api/Api';
import { showToast } from '../../utils/utils';
import { useSelector } from 'react-redux';
import { selectUserInformations } from '../../features/authSlice';

const CourseItems = ({ field, formData, type, handleChange, disabled = false }) => {
    const [courses, setCourses] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    const user = useSelector(selectUserInformations);

    // Initial fetch
    const fetchCourses = useCallback(async (page = 1) => {
        try {
            const { data } = await axios.get(`${API.Courses.app_courses_all}`, {
                params: {
                    page,
                    limit: 20,
                },
                headers: { Authorization: `Bearer ${user.token}` },
            });

            if (data.status === 200 && data.errorCode === 0) {
                if (page === 1) {
                    setCourses(data.data.items);
                } else {
                    setCourses((prev) => [...prev, ...data.data.items]);
                }
                setCurrentPage(page);
                setHasMore(data.data.current_page < data.data.last_page);
                return true;
            } else {
                showToast("Error", "Failed to fetch courses", "error");
                return false;
            }
        } catch (error) {
            showToast(
                "Error",
                error.response?.data?.message || "An error occurred",
                "error"
            );
            return false;
        }
    }, [user.token]);

    // Load more courses with pagination
    const loadMoreCourses = useCallback(async () => {
        if (loading || !hasMore) return;
        setLoading(true);
        await fetchCourses(currentPage + 1);
        setLoading(false);
    }, [currentPage, hasMore, loading, fetchCourses]);

    // Initial load
    useEffect(() => {
        const fetchData = async () => {
            setInitialLoading(true);
            await fetchCourses(1);
            setInitialLoading(false);
        };
        fetchData();
    }, [fetchCourses]);

    const options = courses.map((item) => ({
        id: item.id,
        title: item.title,
        name: item.title,
    }));

    if (initialLoading) {
        return (
            <div className="flex items-center justify-center py-4">
                <div className="w-5 h-5 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }

    return (
        <EnhancedInputField
            key={field.name}
            label={field.label}
            name={field.name}
            type={field.type}
            placeholder={field.placeholder}
            value={formData[field.name]}
            handleChange={handleChange}
            options={options}
            disabled={disabled}
            onLoadMore={hasMore ? loadMoreCourses : null}
            hasMore={hasMore}
            loading={loading}
        />
    )
}

export default CourseItems
